import "./modules/common";
import Vue from "vue";
import Vuelidate from "vuelidate";
import VueApp from "~/Scripts/new/vueApp";
import GMap from "~/Components/Common/GMap.vue";
import ContactCard from "~/Components/Contact/ContactCard.vue";
import QueryCard from "~/Components/Contact/QueryCard.vue";
import ContactForm from "~/Components/Contact/ContactForm.vue";

Vue.use( Vuelidate );

new VueApp( {
  name: "contactUs",
  components: {
    GMap,
    ContactCard,
    QueryCard,
    ContactForm,
  },
  data: () => ( {
    activeLocation: 0,
  } ),
  methods: {
    setActiveLocation ( index ) {
      this.activeLocation = index;
    },
  },
} );
